import * as React from "react";
import Axios from "../../../Components/Axios";
import moment from "moment";
import Chart from "react-apexcharts";

class Bar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            error: false,
            service: this.props.service,
            kpInfo: {},
            now: new Date(),
            stat: [],
            type: this.props.type,
            opacity: 0
        };
    }

    componentDidMount() {

        Axios
            .get('api/services/stat/' + this.state.service + '/' + this.state.type)
            .then(r => {
                this.setState({
                    now: new Date(r.data.now),
                    stat: r.data.stat
                });

                const stat = [...new Array(30)].map((w,i) => {
                    let now = new Date(this.state.now);
                    now.setDate(now.getDate() - i);
                    return {
                        date: moment(now).format('YYYY-MM-DD'),
                        count: 0
                    }
                }).reverse();

                this.state.stat.forEach(
                    v => {
                        const service = stat.find( w => w.date === v.date );
                        (service !== undefined) && (service.count = v.count);
                    }
                );

                this.setState({
                    stat: stat
                });
                setTimeout(() =>
                    this.setState({ opacity: 1 }),
                    200
                );
            })
            .catch((e) => {
                console.log(e);
                this.props.history.push('/auth')
            });
    }

    render() {
        return (
            <div className="card   shadow  border-0 rounded p-2"  style={{opacity: this.state.opacity, transition: 'opacity .4s linear'}}>
                <div className="row">
                    <div className="col-12 pl-4 pt-2">
                        <h5>{this.props.title}</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 px-4">
                        <div className="chart-container">
                            <div>
                                <Chart
                                    type = "bar"
                                    series = {[
                                        {
                                            name: 'Подключения',
                                            data: (this.state.stat ?? []).map(v => v.count)
                                        }
                                    ]}
                                    height={this.props.height ?? 370}
                                    yaxis = {{ show: false}}
                                    options = {
                                        {
                                            chart: {
                                                id: "basic-bar",
                                                toolbar: {show: false}
                                            },
                                            xaxis: {
                                                categories: (this.state.stat ?? []).map(v => +v.date.split('-')[2])
                                            }
                                        }
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}

export default Bar;